import React from "react";
import { Link } from "react-router-dom";
import {
  Home,
  PanelRightOpen,
  PanelRightClose,
  UserCircle,
} from "lucide-react";
import ModelSwitch from "./ModelSwitch";

const ChatHeader = ({
  isMobile,
  onToggleSidebar,
  onToggleProfile,
  modelId,
  setModelId,
  models,
}) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-20">
      <div className="bg-white/80 dark:bg-slate-950/70 backdrop-blur border-b border-slate-200 dark:border-slate-800">
        <div className="mx-auto max-w-5xl px-3 sm:px-4 lg:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={onToggleSidebar}
              className="inline-flex items-center justify-center w-10 h-10 rounded-2xl hover:bg-slate-100 dark:hover:bg-slate-900 transition"
              aria-label="باز و بسته کردن سایدبار"
            >
              {isMobile ? (
                <PanelRightOpen className="w-5 h-5 text-slate-700 dark:text-slate-200" />
              ) : (
                <PanelRightClose className="w-5 h-5 text-slate-700 dark:text-slate-200" />
              )}
            </button>

            <div className="text-right">
              <div className="text-sm font-extrabold text-slate-900 dark:text-white leading-tight">
                چت هوش مصنوعی اوژن
              </div>
              <div className="text-[11px] text-slate-500 dark:text-slate-400">
                انتخاب سریع مدل
              </div>
            </div>

            {/* Desktop: show model switch inline */}
            {!isMobile && (
              <div className="mr-2">
                <ModelSwitch
                  value={modelId}
                  onChange={setModelId}
                  options={models}
                />
              </div>
            )}
          </div>

          <div className="flex items-center gap-2">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-3 h-10 rounded-2xl ring-1 ring-slate-200 dark:ring-slate-800 bg-white/70 dark:bg-slate-900/50 hover:bg-white dark:hover:bg-slate-900 transition text-sm text-slate-700 dark:text-slate-200"
              aria-label="رفتن به خانه"
            >
              <Home className="w-4 h-4" />
              <span className="hidden sm:inline">خانه</span>
            </Link>

            <button
              type="button"
              onClick={onToggleProfile}
              className="inline-flex items-center justify-center w-10 h-10 rounded-2xl hover:bg-slate-100 dark:hover:bg-slate-900 transition"
              aria-label="پروفایل"
            >
              <UserCircle className="w-6 h-6 text-slate-700 dark:text-slate-200" />
            </button>
          </div>
        </div>

        {/* Mobile: place model switch as a small row under header content */}
        {isMobile && (
          <div className="px-3 sm:px-4 lg:px-6 pb-3">
            <div className="flex justify-end">
              <ModelSwitch
                value={modelId}
                onChange={setModelId}
                options={models}
                compact
              />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default ChatHeader;
